import React from 'react';

const Services = () => {
  return (
    <section className="sec deliver" id="deliver">
      <div className="wrap">
        <div className="rev">
          <div className="ey">How We Deliver</div>
          <h2>Three ways we<br/><i>create value</i></h2>
        </div>
        <div className="deliver-grid">
          <div className="deliver-card rev">
            <span className="del-num">{"// "}01</span>
            <span className="del-icon">🚀</span>
            <div className="del-name">AI SaaS Products</div>
            <p className="del-desc">
              We build and operate intelligent software-as-a-service
              products at scale. Subscription-based applications
              with AI at the core — designed for consumer and
              enterprise markets worldwide.
            </p>
            <div className="del-tags">
              <span className="del-tag">Consumer Apps</span>
              <span className="del-tag">Enterprise SaaS</span>
              <span className="del-tag">Mobile & Web</span>
              <span className="del-tag">Global Scale</span>
            </div>
          </div>

          <div className="deliver-card rev d1">
            <span className="del-num">{"// "}02</span>
            <span className="del-icon">⚙️</span>
            <div className="del-name">Technology Services</div>
            <p className="del-desc">
              End-to-end custom development for businesses that
              need bespoke AI solutions. From architecture to
              deployment — we build exactly what your business
              needs, built to last and built to scale.
            </p>
            <div className="del-tags">
              <span className="del-tag">Custom Development</span>
              <span className="del-tag">AI Integration</span>
              <span className="del-tag">Cloud Architecture</span>
              <span className="del-tag">API Development</span>
            </div>
          </div>

          <div className="deliver-card rev d2">
            <span className="del-num">{"// "}03</span>
            <span className="del-icon">💡</span>
            <div className="del-name">Strategic Consulting</div>
            <p className="del-desc">
              Senior advisory for organisations navigating the
              AI era. We help leadership teams define strategy,
              evaluate technology investments, and build the
              roadmap from where they are to where AI can take them.
            </p>
            <div className="del-tags">
              <span className="del-tag">AI Roadmapping</span>
              <span className="del-tag">Digital Strategy</span>
              <span className="del-tag">Technology Audit</span>
              <span className="del-tag">Innovation Advisory</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;